import axios from "../axiosApi";
import {
    FETCH_CASH_CYCLES, RECEIVE_CASH_CYCLES,
    FETCH_CURRENT_CASH_CYCLE, RECEIVE_CURRENT_CASH_CYCLE,
    SAVE_CASH_CYCLE, SAVE_CASH_CYCLE_SUCCESS,
    FETCH_CYCLE_DETAILS, RECEIVE_CYCLE_DETAILS,
    SAVE_CASH_TRANSACTION, SAVE_CASH_TRANSACTION_SUCCESS
} from "../actionTypes";

export const getCashCycles = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_CASH_CYCLES });
        try {
            const filter = JSON.stringify({ "order": "id DESC" });
            const response = await axios.get(`/CashCycles?filter=${filter}`);
            dispatch({ type: RECEIVE_CASH_CYCLES, payload: response.data });
        } catch (e) {
            console.error("getCashCycles ERROR", e);
            dispatch({ type: RECEIVE_CASH_CYCLES, payload: [] });
        }
    }
}

export const getCurrentCashCycle = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_CURRENT_CASH_CYCLE });
        try {
            const filter = JSON.stringify({ "where": { "Status": 1 } });
            const response = await axios.get(`/CashCycles?filter=${filter}`);
            const current = response.data.length > 0 ? response.data[0] : null;
            dispatch({ type: RECEIVE_CURRENT_CASH_CYCLE, payload: current });
        } catch (e) {
            console.error("getCurrentCashCycle ERROR", e);
            dispatch({ type: RECEIVE_CURRENT_CASH_CYCLE, payload: null });
        }
    }
}

export const createCashCycle = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_CASH_CYCLE });
        try {
            const response = await axios.post('/CashCycles', data);
            dispatch({ type: SAVE_CASH_CYCLE_SUCCESS, payload: response.data });
            dispatch(getCashCycles());
            dispatch(getCurrentCashCycle());
        } catch (e) {
            console.error("createCashCycle ERROR", e);
            dispatch({ type: SAVE_CASH_CYCLE_SUCCESS, payload: { error: true } });
        }
    }
}

export const closeCashCycle = (id: number, data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_CASH_CYCLE });
        try {
            const response = await axios.put(`/CashCycles/${id}`, data);
            dispatch({ type: SAVE_CASH_CYCLE_SUCCESS, payload: response.data });
            dispatch(getCashCycles());
            dispatch(getCurrentCashCycle());
        } catch (e) {
            console.error("closeCashCycle ERROR", e);
            dispatch({ type: SAVE_CASH_CYCLE_SUCCESS, payload: { error: true } });
        }
    }
}

export const getCycleDetails = (cycleId: number) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_CYCLE_DETAILS });
        try {
            const filter = JSON.stringify({ "include": ["paymentTypes", "person", {"installments": ["enrollment"]}] });
            const response = await axios.get(`/CashCycles/${cycleId}/CashTransactions?filter=${filter}`);
            dispatch({ type: RECEIVE_CYCLE_DETAILS, payload: response.data });
        } catch (e) {
            console.error("getCycleDetails ERROR", e);
            dispatch({ type: RECEIVE_CYCLE_DETAILS, payload: [] });
        }
    }
}

export const saveCashTransaction = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_CASH_TRANSACTION });
        try {
            const response = await axios.post('/CashTransactions', data);
            dispatch({ type: SAVE_CASH_TRANSACTION_SUCCESS, payload: response.data });
            if (data.CashCycle_id) {
                dispatch(getCycleDetails(data.CashCycle_id));
            }
        } catch (e) {
            console.error("saveCashTransaction ERROR", e);
            dispatch({ type: SAVE_CASH_TRANSACTION_SUCCESS, payload: { error: true } });
        }
    }
}
